import { constants } from '@clubmed/utils';

export const formatContacts = (contacts, locale) =>
  contacts.map(contact => {
    const contactOption = [];
    if (contact.hearingImpairedSupported) {
      contactOption.push('HearingImpairedSupported');
    }
    if (contact.tollFree) {
      contactOption.push('TollFree');
    }
    return {
      '@type': 'ContactPoint',
      telephone: contact.phoneNumber,
      contactType: constants.CONTACT_TYPES[contact.type],
      areaServed: locale.split('-')[1],
      ...(contactOption.length === 0 ? null : { contactOption }),
    };
  });
